import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import { Box, Flex } from 'Components/Base';

import { ANNOUNCEMENT_CATEGORY } from './constants';

/**
 * @param {string} initValue - category [array] | ex. ['NEWS','REMINDER']
 */
const CategorySearch = ({ onChange, value: initValue }) => {
  const [categoryChecked, setCategoryChecked] = useState(
    initValue
      ? {
          NEWS: initValue.includes(ANNOUNCEMENT_CATEGORY.NEWS),
          REMINDER: initValue.includes(ANNOUNCEMENT_CATEGORY.REMINDER),
        }
      : { NEWS: false, REMINDER: false }
  );

  useEffect(() => {
    const category = [];
    if (categoryChecked.NEWS) category.push(ANNOUNCEMENT_CATEGORY.NEWS);
    if (categoryChecked.REMINDER) category.push(ANNOUNCEMENT_CATEGORY.REMINDER);
    onChange({}, { value: [...category] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryChecked]);

  return (
    <Flex flexDirection="column">
      <Checkbox
        label="ข่าวสาร"
        checked={categoryChecked.NEWS}
        onChange={() =>
          setCategoryChecked({ NEWS: !categoryChecked.NEWS, REMINDER: categoryChecked.REMINDER })
        }
      />
      <Box mt={2} />
      <Checkbox
        label="เรียนรู้เพิ่มเติม"
        checked={categoryChecked.REMINDER}
        onChange={() =>
          setCategoryChecked({ NEWS: categoryChecked.NEWS, REMINDER: !categoryChecked.REMINDER })
        }
      />
    </Flex>
  );
};

CategorySearch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
};

export default CategorySearch;
